import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import {PageSaveButton, TableCheckBox} from '../../common/Global/globalStyles.style';
import Sidebar from '../../common/Sidebar';
import Topbar from '../../common/Topbar';
import AlertDialog from '../../common/AlertDialog';
import {
    BrowserRouter as Router,
} from 'react-router-dom';
import UserManagementTopMenu from './topmenu';
import {getLocalStorageVariables,isEmptyVariable,getThemeSettingsVariables,
    isEmptyArray,handleTokenExpiry,
    sortTable} from '../../common/Global/commonFunctions';

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();
const sortDashboardName = "d.dashboardName";
const sortDescription = "d.dashboardDescription";

class EditDashboardRole extends Component {
    constructor(props) {
        super(props);
        let item = props.location.state.dashboardItem;
        this.state = {
            componentDidMountFlag:false,
            showLoader:false,
            departmentId:item.departmentId,
            dashboardRoleName:item.dashboardRoleName ?? "",
            dashboardRoleDescription:item.dashboardRoleDescription ?? "",
            selectedDashboardClientId: [],
            screens:[],
            dashboardRoleId:this.props.match.params.id,
            roleArr:{},
            roleErrors:{},
            singleLevelRoleArr :{},

            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
            dashboardItem: item ?? {},
        }
        this.inputText = React.createRef();
        this.screenNameFlags = {};
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount(){
        this.getUserRoleDetails();
    }

    onCancelClick = () => {
        this.props.history.push(Constants.URL_DASHBOARD_ROLES,{
            dashboardItem: this.state.dashboardItem
        });
    }

    handleAlertDialogCloseInfo = () =>{
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    handleStopPropagation = (e) => {
        e.stopPropagation();
    }

    sortTableLocal = (sortColumn) => {
        let sortObj = sortTable(sortColumn,this.state.sort,this.state.sortDir);

        this.setState({
            sort:sortObj.sortTemp,
            sortDir:sortObj.sortDirTemp,
        },()=>{
            this.getScreensList();
        })
    }

    handleSelection = (item, e) => {
        e.stopPropagation();
        let dashboardClientId = item.dashboardClientId;
        let isChecked = e.target.checked;
        let newDataList = this.state.clientDashboardList;

        newDataList.map((item)=>{
            if(item.dashboardClientId == dashboardClientId) {
                item.isChecked = isChecked;
            }
        })

        let selectedDashboardClientId = this.state.selectedDashboardClientId;
        if(isChecked){
            selectedDashboardClientId.push(dashboardClientId)
        } else {
            selectedDashboardClientId = selectedDashboardClientId.filter(item=>item != dashboardClientId);
        }
        
        this.setState({
            clientDashboardList: newDataList,
            selectedDashboardClientId: selectedDashboardClientId,
        });
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        let FormErrorsTemp = this.state.roleErrors;
        
        if(name === "dashboardRoleName"){
            if(isEmptyVariable(value)){
                FormErrorsTemp['dashboardRoleNameErr'] = "Please enter user role";
            }else{
                FormErrorsTemp['dashboardRoleNameErr'] = "";
            }
        }else if(name === "dashboardRoleDescription"){
            if(!isEmptyVariable(value) && value.length > Constants.DESC_STRING_LENGTH){
                FormErrorsTemp['dashboardRoleDescription'] = "dashboardRoleDescription must be less then 500 characters";
            }else{
                FormErrorsTemp['dashboardRoleDescription'] = "";
            }
        }

        this.setState({ 
            [name]: value,
            roleErrors:FormErrorsTemp
        });
    }
    
    getUserRoleDetails = () => {
        this.setState({
            showLoader:true,
        });

        Promise.all([
            fetch(Constants.GetDashboardRoleCreateMasterData,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    departmentId:this.state.departmentId ?? "",
                })
            }),
            fetch(Constants.DashboardsRoles+"/"+this.state.dashboardRoleId,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                })
            })
        ])
        .then(([masterRes, dashboardRes]) => { 
            return Promise.all([masterRes.json(), dashboardRes.json()]) 
        })
        .then(([masterRes, dashboardRes]) => {
            let clientDashboardList = {};
            let matrix = [];
            let dashboardRoleName = "";
            let dashboardRoleDescription = "";

            if(handleTokenExpiry(masterRes.responseCode)) return;
            else if(masterRes.responseCode === Constants.CODE_SUCCESS){
                clientDashboardList = masterRes.data.clientDashboardList;
            }else{
            }

            if(handleTokenExpiry(dashboardRes.responseCode)) return;
            else if(dashboardRes.responseCode === Constants.CODE_SUCCESS){
                dashboardRoleName = dashboardRes.data.dashboardRoleName;
                dashboardRoleDescription = dashboardRes.data.dashboardRoleDescription;
                matrix = dashboardRes.data.matrix;
                
            }else{
            }
            
            const matrixIds = new Set(
                matrix.map(item => item.dashboardClientId)
            );
            const updatedClientDashboardList = clientDashboardList.map(item => ({
                ...item,
                isChecked: matrixIds.has(item.dashboardClientId)
            }));

            this.setState({
                dashboardRoleName:dashboardRoleName,
                dashboardRoleDescription:dashboardRoleDescription,
                matrix:matrix,
                selectedDashboardClientId:matrix.map(item => item.dashboardClientId),
                clientDashboardList:updatedClientDashboardList,
                showLoader:false
            },()=>{
                this.inputText.current.focus();
            })
        });
    }

    handleSaveButtonClick = () => {
        this.setState({
            showBtnLoader:true,
        });
        let roleErrTemp = {};
        let isError = false;
        if(isEmptyVariable(this.state.dashboardRoleName)){
            isError = true;
            roleErrTemp['dashboardRoleNameErr'] = "Please enter dashboard role";
        }

        if(!isEmptyVariable(this.state.dashboardRoleDescription)){
            if(this.state.dashboardRoleDescription.length > Constants.DESC_STRING_LENGTH){
                isError = true;
                roleErrTemp['dashboardRoleDescription'] = "Description must be less then 500 characters";
            }
        }

        if (this.state.selectedDashboardClientId.length === 0) {
            this.setState({
                showBtnLoader: false,
                showAlertDialogInfo: true,
                alertDialogMessageInfo: "Please select at least one dashboard role."
            });
            return;
        }
        if(isError){
            this.setState({
                roleErrors:roleErrTemp,
                showLoader:false
            });
        }else{
            fetch(Constants.DashboardRoleUpdate,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    departmentId:this.state.departmentId ?? "",
                    dashboardRoleId:this.state.dashboardRoleId,
                    dashboardRoleName:this.state.dashboardRoleName,
                    dashboardRoleDescription:this.state.dashboardRoleDescription,
                    dashboardRoleMatrix:JSON.stringify(this.state.selectedDashboardClientId),
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.setState({
                        showBtnLoader:false,
                    })
                    this.props.history.push(Constants.URL_DASHBOARD_ROLES,{
                        dashboardItem: this.state.dashboardItem
                    });
                }else{
                    this.setState({
                        showBtnLoader:false,
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage
                    })
                }
            });
        }
    }

    render() {
        return(
            <Router>
                <main className="main-dashboard">
                    <section className="dashboard-bg">
                        <Sidebar />

                        <div className="dashboard-right-bg position-relative">
                            <div className="dashboard-wrapper">
                                <Topbar />
                                {
                                    this.state.showLoader &&
                                    <div class="loader"></div>
                                }

                                <UserManagementTopMenu 
                                    themeSettings = {themeSettings}
                                    hideInfo={true}
                                    showDashboardTab={true}
                                />

                                <div className="body-wrapper">
                                    <div className="card-col">
                                        <div className="row custom-row">
                                            <div className="col-md-6 custom-col">
                                                <div className="add-new-form-group">
                                                    <p>Dashboard Role*</p>
                                                    <input 
                                                        name="dashboardRoleName" 
                                                        type="text" 
                                                        value={this.state.dashboardRoleName}
                                                        onChange ={this.handleChange}
                                                        ref={this.inputText}
                                                        placeholder="Type the role name here" 
                                                        spellCheck="true" />
                                                        {
                                                            !isEmptyVariable(this.state.roleErrors['dashboardRoleNameErr']) &&
                                                            <span class="cm-error">{this.state.roleErrors['dashboardRoleNameErr']}</span>
                                                        }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row custom-row">
                                            <div className="col-md-6 custom-col">
                                                <div className="add-new-form-group m-b-0">
                                                    <p>Description</p>
                                                    <textarea 
                                                        name="dashboardRoleDescription" 
                                                        type="text" 
                                                        value={this.state.dashboardRoleDescription}
                                                        onChange ={this.handleChange}
                                                        placeholder="Enter description" 
                                                        spellCheck="true" />
                                                    {
                                                        !isEmptyVariable(this.state.roleErrors['dashboardRoleDescription']) &&
                                                        <span class="cm-error">{this.state.roleErrors['dashboardRoleDescription']}</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card-col">
                                        <div className="review-roles-col">
                                            <h6>Dashboard Roles*</h6>

                                            {!isEmptyArray(this.state.clientDashboardList) && 
                                                <div className="common-tab-bg">
                                                    <div className="common-table" style={{width:"100%"}}>
                                                        <table className="table">
                                                            <thead>
                                                                <tr>
                                                                    <th width={"5%"}></th>
                                                                    <th className="c-pointer" onClick={this.sortTableLocal.bind(this,sortDashboardName)}>
                                                                        <div className="sort-header">Name
                                                                            <span className={(this.state.sort === sortDashboardName)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                        </div>
                                                                    </th>
                                                                    <th className="c-pointer" onClick={this.sortTableLocal.bind(this,sortDescription)}>
                                                                        <div className="sort-header">Description
                                                                            <span className={(this.state.sort === sortDescription)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                        </div>
                                                                    </th>
                                                                    <th>Base template</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    !isEmptyArray(this.state.clientDashboardList) && 
                                                                    this.state.clientDashboardList.map((item,idx) => {
                                                                        return <tr>
                                                                            <td>
                                                                                <TableCheckBox onClick={this.handleStopPropagation} themeSettings={themeSettings} >
                                                                                    <input 
                                                                                        type="checkbox"
                                                                                        name={idx}
                                                                                        id={item.dashboardClientId}
                                                                                        onChange={this.handleSelection.bind(this, item)}
                                                                                        checked={item.isChecked?true:false}
                                                                                    />
                                                                                    <label for={item.dashboardClientId} 
                                                                                    style={{marginLeft:2}}></label>
                                                                                </TableCheckBox>
                                                                            </td>
                                                                            <td>{item.dashboardClientName}</td>
                                                                            <td>{item.dashboardClientDescription}</td>
                                                                            <td>{item.templateName}</td>
                                                                        </tr>
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            }
                                            <div className="common-close-save">
                                                <div className="common-close-save-col">
                                                    <button onClick={this.onCancelClick} type="button" className="common-close">Cancel</button>
                                                    <PageSaveButton 
                                                        themeSettings = {themeSettings}
                                                        onClick={this.handleSaveButtonClick} type="button" className="common-save">Save</PageSaveButton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <AlertDialog 
                            showAlertDialog={this.state.showAlertDialogInfo}
                            handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                            type= {Constants.ALERT_TYPE_ALERT}
                            alertDialogMessage={this.state.alertDialogMessageInfo}
                            proceedBtnClick={this.handleAlertDialogCloseInfo}
                            proceedBtnLabel={ Constants.ALERT_TYPE_OKAY_LABEL }
                            themeSettings = {themeSettings}
                        />
                    </section>
                </main>
            </Router>
        );
    }
}

export default EditDashboardRole;